export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/shoes.042b7b5.svg";